<div class="dialogContainer">
  <div>
    <div class="headerRow">
      <label class="headerLabel">Share a file</label>
    </div>
    <div class="inputRow">
      <label class="inputLabel">File Name:</label>
      <label class="displayLabel">{{ sharedFile.fileName }}</label>
    </div>
    <div class="inputRow">
      <label class="inputLabel">Share With:</label>
      <input class="standardTextBox" [(ngModel)]="sharedFile.sharedWithEmail" placeholder="example@company.com"/>
    </div>
    <div class="inputRow">
      <label class="inputLabel">Expires in:</label>
      <input class="numberInput" type="number" [(ngModel)]="sharedFile.validDays" min="1" max="7"/>
      <label class="numberLabel">days</label>
    </div>
    <div class="buttonRow">
      <span class="spacer"></span>
      <button class="dialogButton warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
      <button class="dialogButton primary-button" matButton="elevated" (click)="share()">Share</button>
    </div>
    @if (errorMessage()) {
      <div class="errorMessage">
        <pre>{{ errorMessage() }}</pre>
      </div>
    }
  </div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
